module.exports = __webpack_public_path__ + "static/2-2c837cac3a697a1d894ee6327347b48c.jpg";